import RekapitulasiNilaiPersediaan from "./RekapitulasiNilaiPersediaan";

export default RekapitulasiNilaiPersediaan;
